import React from 'react';
import './DoubleRangeSlider.scss';

const DoubleRangeSlider = ({ min, max, minValue, maxValue, onChange, hideInputs }) => {
    const handleMinChange = (e) => {
        const value = Math.min(Number(e.target.value), maxValue - 1);
        onChange({ min: value, max: maxValue });
    };

    const handleMaxChange = (e) => {
        const value = Math.max(Number(e.target.value), minValue + 1);
        onChange({ min: minValue, max: value });
    };

    const getPercent = (value) => ((value - min) / (max - min)) * 100;

    return (
        <div className="double-range-slider">
            <div className="slider-track">
                <div
                    className="slider-range"
                    style={{
                        left: `${getPercent(minValue)}%`,
                        width: `${getPercent(maxValue) - getPercent(minValue)}%`
                    }}
                />
                <input
                    type="range"
                    min={min}
                    max={max}
                    value={minValue}
                    onChange={handleMinChange}
                    className="thumb thumb-left"
                />
                <input
                    type="range"
                    min={min}
                    max={max}
                    value={maxValue}
                    onChange={handleMaxChange}
                    className="thumb thumb-right"
                />
            </div>
            {!hideInputs && <div className="value-display-container">
                <span>£</span><input
                    type="number"
                    min={min}
                    max={max}
                    value={minValue}
                    onChange={handleMinChange}
                    className='input-cont-range'
                /> to   <span>£</span><input
                    type="number"
                    min={min}
                    max={max}
                    value={maxValue}
                    onChange={handleMaxChange}
                    className='input-cont-range'
                />
            </div>}
        </div>
    );
};

export default DoubleRangeSlider;
